exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.model-item[data-v-2c2efb08] {\r\n  margin-bottom: 20px;\n}\n.model-desc[data-v-2c2efb08] {\r\n  color: #999;\r\n  font-size: 12px;\r\n  line-height: 16px;\r\n  margin: 4px 0 0 25px;\n}\n.model-warn[data-v-2c2efb08] {\r\n  color: #f5222d;\r\n  margin-top: 8px;\r\n  line-height: 20px;\n}\n.warn-strong[data-v-2c2efb08] {\r\n  font-weight: bold;\n}\r\n", ""]);

// exports
